import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import { Text } from 'preact-i18n';

import store from '../../store';

import ServiceWrapper from './serviceWrapper'

export default  class aService extends Component {
	render() {
		return (<ServiceWrapper {...this.props}>
						<article class="has-widget">
							<p>DolphinHost™ mākoņskaitļošanas datu centrā izvietots failu serveris, kas pieejams tikai no Abonenta iekšējā tīkla un nodrošina visu saglabāto failu šifrēšanu. Savietojams ar Windows, Macintosh un Linux darbstacijām. Administratoram iespēja noteikt individuālas piekļuves tiesības mapēm un failiem. </p>
							<h2>Priekšrocības</h2>
							<ul>
								<li>Ātrdarbīgs failu serveris</li>
								<li>Aizsardzība pret datu zudumiem (visi dati tiek glabāti 3 kopijās uz fizisiki neatkarīgām iekārtām).</li>
								<li>Aizsardzība pret vīrusiem</li>
								<li>Iespēja ērti administrēt lietotājus, izmantojot administrēšanas vidi</li>
								<li>Datu centra un e-pasta infrastruktūras atbilstība GDPR datu aizsardzības regulai</li>
							</ul>
						</article>
						<div class="widget plan">
							<h3><span class="from"><Text id="cart.from"/></span><span class="value">€10</span><span class="term"> <Text id="cart.month.full"/></span></h3>
						     <ul class="bullet">
						     	<li>Bezmaksas ierīkošana</li>
						     	<li>10% atlaide maksājot par 12 mēnešiem</li>
						     </ul>
						     <div><Link href={store.prefix+'/contact?service=files&form=true'} class="button"><Text id="email.widget.list.btn"/></Link></div>
						</div>
				</ServiceWrapper>);
	}
}



// WEBPACK FOOTER //
// ./routes/services/files.js